import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Alert } from 'reactstrap';
import "./styles.css"
import { RenderIf } from '../../helpers/RenderIf';
import { AlertText } from '../Traks/AlertTexts';


const AlertModal = ({ text, type, isShowing, setIsShowing }) => {
	let className = type + " position-relative"

	useEffect(() => {
		if(isShowing)
			window.setTimeout(() => {
				setIsShowing(false);
			}, 4000);

	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isShowing])

	const portalContainer = document.getElementById("app_root");
	return isShowing && (
		ReactDOM.createPortal(
			<React.Fragment>
				<div className="alert-modal" >
					<Alert isOpen={isShowing} className={className}>
						<div className="d-flex justify-content-between border_radius_6px"  onClick={() => setIsShowing(false)}>
							<div className="fw_600 me-5">
								<AlertText text={text} />
							</div>
							<RenderIf condition={isShowing !== null}>
								<div className="fw_700 cursor_pointer" onClick={() => setIsShowing(false)}>
									X
								</div>
							</RenderIf>
						</div>
					</Alert>
				</div>
			</React.Fragment >, portalContainer)
	)
}
export default AlertModal;

